export const MENU_TRIGGER_ID = "icon-button-scheduled-exports-menu-trigger"
export const MENU_ID = "icon-button-scheduled-exports-menu"

export const EXPORT_SCHEDULE_MODAL_TRIGGER_ID =
  "button-scheduled-exports-modal-trigger"

export const FREQUENCY_MONTHLY = "MONTHLY"

const WEEKDAYS = {
  0: "Sunday",
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  7: "Sunday",
}

const MONTHDAYS = {}
for (let i = 1; i <= 28; i++) {
  let postfix = ""
  switch (i % 10) {
    case 1:
      postfix = "st"
      break
    case 2:
      postfix = "nd"
      break
    case 3:
      postfix = "rd"
      break
    default:
      postfix = "th"
  }

  MONTHDAYS[i] = `${i}${postfix}`
}

const objectToOptions = (obj) => {
  return Object.keys(obj).map((key) => ({
    value: key,
    label: obj[key],
  }))
}

export const DAYS_OF_MONTH = objectToOptions(MONTHDAYS)
export const DAYS_OF_WEEK = objectToOptions(WEEKDAYS)
